export class GlobalActivitiesRequest {
    StartDate: Date;
    EndDate: Date;
}
